import React, { forwardRef } from 'react';
import { apiBase } from '../../utils/config';
import CommonConfig from '../../utils/constant';

const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
};

const formatTime = (t) => {
    if (!t) return '';
    const d = new Date(t);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
};

const cell = { border: '1px solid #000', padding: '3px 6px', fontSize: 11, verticalAlign: 'middle' };
const headCell = { ...cell, fontWeight: 'bold', textAlign: 'center', background: '#fff' };

const HallTicketExportPDF = forwardRef((props, ref) => {
    const meta = props?.meta || {};
    const students = props?.pdfData || [];
    const allSubjects = meta?.Subjects || [];
    const subjectsForStudent = (stu) => allSubjects.filter(sub =>
        !sub?.IsOptional || (sub?.AssignedStudentIds || []).map(String).includes(String(stu?.id)));
    const fileToken = CommonConfig.fileToken();
    const logoUrl = meta?.SchoolLogo ? `${apiBase}/UserProfilePic/${meta.SchoolLogo}?token=${fileToken}` : null;
    const signUrl = meta?.PrincipalSignImage ? `${apiBase}/TemplateSign/${meta.PrincipalSignImage}?token=${fileToken}` : null;
    const waterMarkUrl = meta?.WaterMarkImage ? `${apiBase}/TemplateSign/${meta.WaterMarkImage}?token=${fileToken}` : null;
    const waterMarkOpacity = (() => {
        const n = Number(meta?.WaterMarkOpacity);
        if (isNaN(n)) return 0.12;
        return Math.max(0, Math.min(100, n)) / 100;
    })();

    const pairs = [];
    for (let i = 0; i < students.length; i += 2) pairs.push(students.slice(i, i + 2));

    const renderTicket = (stu, idx) => (
        <div id={`hallticket-${idx}`} style={{ position: 'relative', width: '100%', padding: '6px 12px', boxSizing: 'border-box', fontFamily: 'Times New Roman, serif', color: '#000' }}>
            {waterMarkUrl &&
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none', zIndex: 0 }}>
                    <img src={waterMarkUrl} alt="" style={{ width: '55%', maxWidth: 300, opacity: waterMarkOpacity, objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />
                </div>}
            <table style={{ position: 'relative', zIndex: 1, width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                <tbody>
                    <tr>
                        <td style={{ ...cell, width: '22%', textAlign: 'center' }}>
                            {logoUrl ? <img src={logoUrl} alt="logo" style={{ maxWidth: '100%', maxHeight: 55, objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} /> : <div style={{ fontWeight: 'bold' }}>{meta?.SchoolName}</div>}
                            <div style={{ fontSize: 9, marginTop: 2 }}>{meta?.SchoolName}</div>
                        </td>
                        <td style={{ ...cell, width: '56%', textAlign: 'center', padding: 0 }}>
                            <div style={{ borderBottom: '1px solid #000', padding: '5px', fontSize: 14, fontWeight: 'bold' }}>{meta?.ExamTitle} &nbsp;&nbsp; HALL TICKET</div>
                            <div style={{ borderBottom: '1px solid #000', padding: '5px', fontSize: 13, fontWeight: 'bold' }}>{meta?.SecondRow?.trim() ? meta.SecondRow : <>{meta?.IsSemester ? `SEM -- ${meta?.ClassNo || ''}` : (meta?.ClassNo || '')} &nbsp;&nbsp; {meta?.Board}</>}</div>
                            <div style={{ padding: '5px', fontSize: 13, fontWeight: 'bold' }}>{meta?.ThirdRow?.trim() ? meta.ThirdRow : meta?.MonthYear}</div>
                        </td>
                        <td style={{ ...cell, width: '22%', textAlign: 'center' }}>
                            <div style={{ position: 'relative', width: 56, height: 72, margin: '0 auto', border: '1px solid #000' }}>
                                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', color: '#999', fontStyle: 'italic', fontSize: 8, lineHeight: 1.2, padding: 2 }}>AFFIX YOUR PASSPORT SIZE PHOTO HERE</div>
                                {stu?.ProfilePhotoUrl
                                    ? <img src={`${apiBase}/UserProfilePic/${stu.ProfilePhotoUrl}?token=${fileToken}`} alt="student" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', background: '#fff' }} onError={(e) => { e.target.style.display = 'none'; }} />
                                    : null}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table style={{ position: 'relative', zIndex: 1, width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                <tbody>
                    <tr>
                        <td style={{ ...cell, width: '22%', fontWeight: 'bold' }}>STUDENT'S NAME</td>
                        <td style={{ ...cell, width: '78%' }} colSpan={3}>{stu?.Name || ''}</td>
                    </tr>
                    <tr>
                        <td style={{ ...cell, width: '22%', fontWeight: 'bold' }}>ENROLLMENT No.</td>
                        <td style={{ ...cell, width: '40%' }}>{stu?.StudentId || ''}</td>
                        <td style={{ ...cell, width: '13%', fontWeight: 'bold' }}>ROLL No.</td>
                        <td style={{ ...cell, width: '25%' }}>{stu?.RollNo || ''}</td>
                    </tr>
                </tbody>
            </table>

            <table style={{ position: 'relative', zIndex: 1, width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                <thead>
                    <tr>
                        <th style={{ ...headCell, width: '6%' }}>SR. No.</th>
                        <th style={{ ...headCell, width: '15%' }}>ALLOTTED BLOCK</th>
                        <th style={{ ...headCell, width: '25%' }}>SUBJECT NAME</th>
                        <th style={{ ...headCell, width: '15%' }}>SUBJECT CODE</th>
                        <th style={{ ...headCell, width: '13%' }}>EXAM DATE</th>
                        <th style={{ ...headCell, width: '16%' }}>EXAM TIME</th>
                        <th style={{ ...headCell, width: '10%' }}>SIGN OF INVIGILATOR</th>
                    </tr>
                </thead>
                <tbody>
                    {subjectsForStudent(stu).map((sub, si) => (
                        <tr key={si}>
                            <td style={{ ...cell, textAlign: 'center' }}>{si + 1}</td>
                            <td style={{ ...cell, textAlign: 'center' }}>{stu?.Block || ''}</td>
                            <td style={cell}>{sub?.SubjectName || ''}</td>
                            <td style={{ ...cell, textAlign: 'center' }}>{sub?.SubjectCode || ''}</td>
                            <td style={{ ...cell, textAlign: 'center' }}>{formatDate(sub?.ExamDate)}</td>
                            <td style={{ ...cell, textAlign: 'center' }}>{sub?.StartTime ? `${formatTime(sub?.StartTime)} to ${formatTime(sub?.EndTime)}` : ''}</td>
                            <td style={cell}></td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <table style={{ position: 'relative', zIndex: 1, width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                <tbody>
                    <tr>
                        <td style={{ ...cell, width: '70%', verticalAlign: 'top', padding: 0 }}>
                            <div style={{ ...headCell, borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}>EXAM RULES</div>
                            {(meta?.ExamRules || []).map((rule, ri) => (
                                <div key={ri} style={{ borderBottom: '1px solid #000', padding: '2px 6px', fontSize: 9 }}>{ri + 1}. {rule}</div>
                            ))}
                        </td>
                        <td style={{ ...cell, width: '30%', textAlign: 'center', verticalAlign: 'bottom' }}>
                            {signUrl ? <img src={signUrl} alt="sign" style={{ maxHeight: 50, maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} /> : <div style={{ height: 40 }} />}
                            <div style={{ fontWeight: 'bold', marginTop: 2 }}>PRINCIPAL</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );

    return (
        <div ref={ref} id="pdf-hallticket-content">
            {pairs.map((pair, pi) => (
                <div key={pi} style={{ pageBreakAfter: pi < pairs.length - 1 ? 'always' : 'auto', pageBreakInside: 'avoid' }}>
                    {pair.map((stu, j) => {
                        const idx = pi * 2 + j;
                        return (
                            <React.Fragment key={stu?.id || idx}>
                                {renderTicket(stu, idx)}
                                {j === 0 && pair.length === 2 && (
                                    <div style={{ borderTop: '2px dotted #000', margin: '10px 12px' }} />
                                )}
                            </React.Fragment>
                        );
                    })}
                </div>
            ))}
        </div>
    );
});

export default HallTicketExportPDF;
